import { render, staticRenderFns } from "./SignatureSection.vue?vue&type=template&id=127d9ce9&scoped=true&"
import script from "./SignatureSection.vue?vue&type=script&lang=js&"
export * from "./SignatureSection.vue?vue&type=script&lang=js&"
import style0 from "./SignatureSection.vue?vue&type=style&index=0&id=127d9ce9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "127d9ce9",
  null
  
)

export default component.exports